import {inject, Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {Observable} from "rxjs";

@Injectable({providedIn: "root"})
export class GenericApiService {

    protected http = inject(HttpClient);

    public get<T>(url: string): Observable<T> {
        return this.http.get(url) as Observable<T>
    }

    public post<T>(url: string, data: any, opts?: any): Observable<T> {
        return this.http.post(url, data, opts) as Observable<T>
    }

    public put<T>(url: string, data: any): Observable<T> {
        return this.http.put(url, data) as Observable<T>
    }

    public delete<T>(url: string): Observable<T> {
        return this.http.delete(url) as Observable<T>
    }

}


